import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  AcademyModuleSelect,
  rescheduleClassesCurrentFiltersSelector,
  RESCHEDULE_CLASSES_FILTERS,
  setRescheduleFilterValue,
} from 'features/classCreation';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';

function RescheduleClassesAcademyModuleFilter({ sbatGroups }) {
  const dispatch = useDispatch();
  const { academyModules } = useSelector(
    rescheduleClassesCurrentFiltersSelector
  );

  const handleOnChange = useCallback(
    (option) => {
      dispatch(
        setRescheduleFilterValue({
          key: RESCHEDULE_CLASSES_FILTERS.academyModules,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="Module Names"
      labelClassName="h5"
    >
      <AcademyModuleSelect
        sbatGroups={sbatGroups}
        value={academyModules}
        placeholder="Select from dropdown"
        onChange={handleOnChange}
      />
    </Field>
  );
}

export default RescheduleClassesAcademyModuleFilter;
